const authUser = JSON.parse(localStorage.getItem("authUser"));
export default authUser;
